import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { useAuth } from '@/contexts/AuthContext'
import { Layout } from '@/components/Layout'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { LoggerControl } from '@/components/LoggerControl'
import { LoginPage } from '@/pages/LoginPage'
import { RegisterPage } from '@/pages/RegisterPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { TaskDrawerProvider } from '@/contexts/TaskDrawerContext'
import { TaskDrawer } from '@/components/tasks/drawer/TaskDrawer'
import { LegacyTaskRedirect } from '@/components/tasks/drawer/LegacyTaskRedirect'
import { HOME_PATH, PAGE_ROUTES, REDIRECTS } from '@/routes/app-routes'

function App() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto" aria-hidden="true"></div>
          <p className="mt-4 text-muted-foreground">Carregando aplicação...</p>
        </div>
      </div>
    )
  }

  return (
    <TooltipProvider delayDuration={300}>
    <TaskDrawerProvider>
    <div className="min-h-screen bg-muted">
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={isAuthenticated ? <Navigate to={HOME_PATH} replace /> : <LoginPage />} />
        <Route path="/register" element={isAuthenticated ? <Navigate to={HOME_PATH} replace /> : <RegisterPage />} />

        {/* Páginas autenticadas (tabela em routes/app-routes.tsx) */}
        {PAGE_ROUTES.map(({ path, element, permission }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute requiredPermission={permission}>
                <Layout>{element}</Layout>
              </ProtectedRoute>
            }
          />
        ))}

        {/* Rotas antigas de tarefas → gaveta */}
        <Route path="/tasks/new" element={<LegacyTaskRedirect />} />
        <Route path="/tasks/create" element={<LegacyTaskRedirect />} />
        <Route path="/tasks/:id" element={<LegacyTaskRedirect />} />
        <Route path="/tasks/:id/edit" element={<LegacyTaskRedirect />} />
        <Route path="/tasks/:id/review" element={<LegacyTaskRedirect />} />

        {/* Favoritos antigos → telas novas */}
        {REDIRECTS.map(({ from, to }) => (
          <Route key={from} path={from} element={<ProtectedRoute><Navigate to={to} replace /></ProtectedRoute>} />
        ))}

        {/* Catch all route */}
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Layout>
                <NotFoundPage />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>

      {/* Gaveta única de tarefa (aberta de qualquer tela autenticada) */}
      <TaskDrawer />

      {/* Global toast notifications */}
      <Toaster
        position="top-right"
        expand={false}
        richColors
        closeButton
      />

      {/* Logger Control (apenas em desenvolvimento) */}
      <LoggerControl />

    </div>
    </TaskDrawerProvider>
    </TooltipProvider>
  )
}

export default App
